import React, { ReactElement } from 'react';
import Styled from './Header.styled';
import { ComponentProps } from './Header.types';
import { Heading } from '../../../atoms';

const Header: React.FC<ComponentProps> = ({ title, ...props }): ReactElement<ComponentProps> => {
  return (
    <Styled px={12} pt={12} {...props}>
      <Heading variant="primary" mode="subheading" weight="bold">
        {title}
      </Heading>
    </Styled>
  );
};

export default Header;
